import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class DateFormatService {
  private format!: string;

  constructor(private http: HttpClient) {}

  loadFormat(): Promise<void> {
    return firstValueFrom(
      this.http.get(environment.apiUrl + 'references/dateFormat', { responseType: 'text' })
    ).then(format => {
      this.format = format;
    }).catch(() => {
      this.format = 'MM/dd/yyyy'; // default fallback
    });
  }

  getFormat(): string {
    return this.format;
  }
}